import React, { useState, useEffect, useContext } from 'react'
import {  } from '@material-ui/icons'

import Modal from '../../UI/Modal'
import Loader from '../../UI/Loader'
import Button from '../../UI/Button'
import { fetch_site_manufacturers } from '../../../services/firestore'
import { UserContext } from '../../../context/user/userState'

const AgencyModal = ({ onClose, onSetDocValues, token }) => {
  const { user, setUser, userAgencies, userAgenciesFetched, setUserAgencies, setUserAgenciesFetched } = useContext(UserContext)
  const [loading, setLoading] = useState(true)
  const [agencies, setAgencies] = useState([])
  const [isReady, setIsReady] = useState(false) 

  useEffect(() => {
    if(userAgenciesFetched && !isReady) {
      setAgencies(userAgencies)
      setIsReady(true)
      setLoading(false)
    }else {
      if(!isReady) {
        const fetchData = async () => {
          try {
            const res = await fetch_site_manufacturers(token)
            if(res && Array.isArray(res)) {
              // console.log(res)
              setAgencies(res)
              setUserAgencies(res)
              setUserAgenciesFetched(true)
            }
          } catch (err) {
            console.log(err)
          }
          setLoading(false)
        }
        fetchData()
      }
    }
  }, [token, userAgenciesFetched, setUserAgenciesFetched, isReady, setUserAgencies, userAgencies]) 

  // On agency button click
  const onAgencySelect = (agency) => {
    // console.log(agency)
    setUser({
      ...user,
      manufacturer: agency
    })
    onSetDocValues(prev => ({
      ...prev,
      manufacturers_name: agency.name || '',
      // manufacturers_contact_firstname: '',
      // manufacturers_contact_name: '',
      adresse: agency.address || '',
      postal_code: agency.postal_code || '',
      city: agency.city || '',
      telephone: agency.phone || '',
      email: agency.email || '',
      manufacturers_description: agency.description || '',
      // admin_fonction: ''
    }))
    onClose()
  }

  return (
    <Modal onClose={onClose} noPadding>
      <div className="agency-modal">
        <div className="agency-modal__head">
          <h2>Changer les coordonnées de l'agence</h2>
        </div>
        <div className="agency-modal__body">
          {loading 
            ? <div className="loader-wrapper"><Loader primary small normal /></div>
            : (
              <div className="agency-modal__body_boxes">
                {agencies.map((agency, i) => {
                  return (
                    <div className="agency-box" key={i}>
                      <div className="agency-box__head">
                        {/* <h3>{agency.metiers ? agency.metiers.map((m, i) => <span key={i}>{m.name}</span>) : ''}</h3> */}
                        <Button primary text="Sélectionner" onButtonClick={() => onAgencySelect(agency)} />
                      </div>
                      <div className="agency-box__body">
                        <p><strong>Agence:</strong> {agency.name}</p>
                        <p><strong>Adresse siège:</strong> {agency.address}</p>
                        <p><strong>Numéro de carte:</strong> </p>
                      </div>
                    </div>
                  )
                })}
              </div>
            )
          }
        </div>
      </div>
    </Modal>
  )
}

export default AgencyModal